<template>
    <section class="section-material">
      <SpecificItemPage v-if="material && material.foto_file" :main-img="material.foto_file" :img-name="material.nombre">
        <template #grid-content>
          <DinamicGridImages :obras="material.obras" />
        </template>
      </SpecificItemPage>
    </section>
</template>

<script>
import { isMobile } from 'mobile-device-detect'
import MaterialesService from '../services/MaterialesService'
import { EventBus } from '@/event-bus'
import SpecificItemPage from '../components/SpecificItemPage.vue'
import DinamicGridImages from '../components/DinamicGrid/Images'
export default {
  name: 'Material',
  components: {
    SpecificItemPage,
    DinamicGridImages
  },
  data () {
    return {
      isMobile,
      id: this.$route.params.material.split('-')[0],
      material: []
    }
  },
  methods: {
    getMaterialById () {
      const service = new MaterialesService()
      EventBus.$emit('toggleLoading', true)
      service.findAll({}, response => {
        this.material = response.find(m => m.id === this.id)
        EventBus.$emit('toggleLoading', false)
        EventBus.$emit('showTitlePage', this.material.nombre)
      })
    }
  },
  mounted () {
    this.getMaterialById()
    EventBus.$emit('toggleHeaderFamilyIcons', false)
    EventBus.$emit('toggleGridFamilyIcon', true)
  }
}
</script>

<style scoped lang="scss">
  .section-material{
    background: #1A1A1A;
  }
</style>
